import {ComposerTranslation, useI18n} from 'vue-i18n'

const cache: Map<string, string> = new Map()
let t: ComposerTranslation

const useCachedT = () => {
    return {
        cachedT: (key: string) => {
            if (!t) {
                t = useI18n().t
            }
            if (!cache.has(key)) {
                cache.set(key, t(key))
            }
            return cache.get(key) || key
        }

    }
}


export {useCachedT}